import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const TAX_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('name', 'Entity.Tax.Name')
    .required()
    .minLength(3)
    .maxLength(50)
    .build(),
  FieldBuilder.text('sapCode', 'Entity.Tax.SapCode')
    .required()
    .minLength(2)
    .maxLength(2)
    .build(),
  FieldBuilder.number('taxValue', 'Entity.Tax.TaxValue')
    .required()
    .build(),
  FieldBuilder.number('certificateValue', 'Entity.Tax.CertificateValue')
    .required()
    .build(),
  FieldBuilder.number('retentionValue', 'Entity.Tax.RetentionValue')
    .required()
    .build(),
];

export const TAX_CONFIG = {
  entityName: 'Tax',
  localizationKey: 'Controlling::Entity.Tax',
  fields: TAX_FIELDS,
  permission: 'ControllingLiquidations.Taxes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
